import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DTypeFormRatingField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'rating-field-component',
    templateUrl: './rating-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule]
})
export class DtypeRatingFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormRatingField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    views: boolean[];
    value: number;
    touched: boolean;

    constructor() { }

    ngOnInit() {
        this.views = new Array(this.field.max);
        this.value = this.field.control.value ? this.field.control.value : 0;
        if (!this.field.control.value) {
            this.views.fill(false);
        } else {
            for (let i = this.field.control.value - 1; i >= 0; i--) {
                this.views[i] = true;
            }
        }
        this.field.control.valueChanges.subscribe((value) => {
                this.value = value;
                if (this.value === 0) {
                    this.field.control.setErrors({ 'incorrect': true });
                }
        });
    }

    markRating(index: number, firstTime?: boolean) {
        if (!firstTime) {
            this.touched = true;
        }
        if (index + 1 === this.value) {
            this.field.control.setValue(0);
            this.views.fill(false);
        } else if (index + 1 < this.value) {
            for (let i = index + 1; i < this.views.length; i++) {
                this.views[i] = false;
            }
            this.field.control.setValue(index + 1);
        } else {
            const ind = this.value === 0 ? this.value : this.value - 1;
            for (let i = ind; i < index + 1; i++) {
                this.views[i] = true;
            }
            this.field.control.setValue(index + 1);
        }
        this.value = firstTime ? this.field.control.value : this.value;
    }

}
